import { api } from "./api";

export const PuestoService = {
    //Obtener todos los puestos
    getAll: () => {
        return api.get("/roles/puestos");
    }
}

export const RolService = {
    //Obtener todos los roles
    getAll: () => {
        return api.get("/roles");
    }
}